import React, { useState } from 'react';
import { IconButton, Popover, Card } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import Checkbox from '../../../../common/components/Checkbox/Checkbox';
import MenuItem from '../../../../common/components/MenuItem/MenuItem';
import TooltipWrapper from '../../../../common/components/Form/TooltipWrapper';

const styles = {
  smallIcon: {
    width: 20,
    height: 20,
  },
  small: {
    width: 20,
    height: 20,
  },
  popover: {
    marginLeft: '-19px',
  },
  menuStyle: {
    minWidth: '130px',
    maxWidth: '130px',
  },
};

export const multiselectionModes = {
  ALL_PAGES: 'All Pages',
  CURRENT_PAGE: 'Current Page',
};

export const handleMultiselect = ({ selectionMode, setAllSelected, setCurrentPageSelected, deselectAllRows }) => {
  switch (selectionMode) {
    case 'ALL_PAGES': {
      setAllSelected();
      break;
    }
    case 'CURRENT_PAGE': {
      setCurrentPageSelected();
      break;
    }
    case null:
    default: {
      deselectAllRows();
      break;
    }
  }
};

function TableMultiselect(props) {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const handleClick = (event) => {
    event.preventDefault();
    setAnchorElement(event.currentTarget);
    setDropdownOpen(true);
  };

  const handleRequestClose = () => {
    setDropdownOpen(false);
  };

  const handlePropsSelect = (selectionMode) => {
    props.onSelect(selectionMode);
  };

  const handleOptionSelect = (selectionMode) => {
    handlePropsSelect(selectionMode);
    handleRequestClose();
  };

  const handleMainCheckClicked = () => {
    const desiredCheckState = props.selectedCount === 0;
    const selectionMode = desiredCheckState ? 'ALL_PAGES' : null;

    handlePropsSelect(selectionMode);
  };

  const getPopoverMenu = () => {
    const menuItems = Object.entries(multiselectionModes)
      .sort((a, b) => (a[1] > b[1] ? 1 : -1))
      .map((item) => (
        <MenuItem key={`menu-item-${item[0]}`} onClick={() => handleOptionSelect(item[0])} title={item[1]}>
          {item[1]}
        </MenuItem>
      ));

    return <Card style={styles.menuStyle}>{menuItems}</Card>;
  };

  const popoverMenu = getPopoverMenu();
  const multiselectComponent = (
    <div className="table-multi-select-container checkbox-cell">
      <Checkbox noPadding checked={props.selectedCount > 0} onChange={handleMainCheckClicked} />
      <IconButton style={styles.small} onClick={handleClick}>
        <ExpandMore />
      </IconButton>
      <Popover
        open={isDropdownOpen}
        anchorEl={anchorElement}
        style={styles.popover}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        onClose={handleRequestClose}
      >
        {popoverMenu}
      </Popover>
    </div>
  );

  const tooltipContent = props.selectedCount > 0 ? props.selectedCount : null;

  return tooltipContent ? (
    <TooltipWrapper tip={tooltipContent} position="top" arrow>
      {multiselectComponent}
    </TooltipWrapper>
  ) : (
    multiselectComponent
  );
}

export default TableMultiselect;
